function PlayerProfile({
    color,
    name,
    image,
    isActive,
    isComputer,
    dice,
    rolling,
    onRoll,
    canRoll,
    hasRolled,
}) {
    return (
        <div
            className={`player-seat player-seat-${color}`}
        >

            {/* ================================
                PROFILE
            ================================= */}
            <div
                className={`player-profile ${
                    isActive
                        ? "active-player"
                        : ""
                }`}
            >

                <img
                    src={image}
                    alt={name}
                    className={`player-photo ${color}`}
                />

                <div className="player-info">

                    <div className="player-name">
                        {name}
                    </div>

                </div>

            </div>


            {/* ================================
                DICE
                Only current player sees dice
            ================================= */}
            {isActive && (
                <div className="profile-dice">

                    <img
                        src={
                            rolling
                                ? "/assets/draw.gif"
                                : !hasRolled
                                    ? "/assets/roll.png"
                                    : `/assets/${dice}.png`
                        }
                        alt={
                            rolling
                                ? "Rolling"
                                : hasRolled
                                    ? `Dice ${dice}`
                                    : "Roll Dice"
                        }
                        className={`
                            profile-dice-image
                            ${
                                !canRoll || rolling
                                    ? "dice-disabled"
                                    : "dice-clickable"
                            }
                        `}
                        onClick={() => {

                            if (
                                !rolling &&
                                canRoll &&
                                !hasRolled
                            ) {
                                onRoll();
                            }

                        }}
                    />

                </div>
            )}

        </div>
    );
}

export default PlayerProfile;